import { render, staticRenderFns } from "./Sidebox.vue?vue&type=template&id=969f8570"
import script from "./Sidebox.vue?vue&type=script&lang=js"
export * from "./Sidebox.vue?vue&type=script&lang=js"
import style0 from "./Sidebox.vue?vue&type=style&index=0&id=969f8570&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports